import { useState, useEffect, useCallback } from 'react'
import FieldValidator from '../Core/FieldValidator'
import { getNewSpecification } from '../Core/ContainerFunctions'
import omitBy from 'lodash/omitBy'
import isEmpty from 'lodash/isEmpty'
import { useScript } from './index'

export default function useSpecification({ validatorSrc, fetchResource, className = 'Validator', onInit }) {
  const [loaded, error] = useScript(validatorSrc)
  const [validator, setValidator] = useState(null)

  const validate = useCallback(
    (data, fullData = {}) => {
      if (loaded && validator && data) {
        const [newSpecificationValues, specification] = getNewSpecification(validator, { ...fullData, ...data })
        const newFormData = validator.filterDisabled(newSpecificationValues, specification)
        const errors = validator.validate(newFormData, specification)
        const filteredErrors = omitBy(errors, (error) => error.error_type === 'missing_string_enum_resource')

        return {
          isValid: isEmpty(filteredErrors),
          errors: filteredErrors,
          specification,
        }
      }
      return { isValid: false, errors: {} }
    },
    [validator, loaded],
  )

  useEffect(() => {
    if (loaded && className in window) {
      const newValidator = new FieldValidator(() => {}, fetchResource, className)
      setValidator(newValidator)
      onInit(newValidator.getActualSpecification(), newValidator)
    }
  }, [loaded, className in window])

  return {
    validate,
    loaded,
  }
}
